<app-visitor-card-details
  [identity]="identity"
  [visitorCardStubs]="recentVisitorCards"
></app-visitor-card-details>
<app-visitor-card-account-details
  *ngIf="visitorCard"
  [visitorCard]="visitorCard"
  [customerAccount]="customerAccount"
></app-visitor-card-account-details>
<app-visitor-cards-transaction-history
  *ngIf="visitorCard"
  [visitorCard]="visitorCard"
></app-visitor-cards-transaction-history>
